<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>试卷管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" size="small" :model="formInline" class="user-search">
            <el-form-item label="试卷名称：">
                <el-input size="small" v-model="formInline.examNameLike" placeholder="请输入试卷名称"></el-input>
            </el-form-item>
            <el-form-item label="科目类别：">
                <el-select clearable v-model="formInline.courseCategoryId">
                    <el-option v-for="item in courseList" :key="item.courseCategoryId" :label="item.courseCategoryName"
                        :value="item.courseCategoryId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="命题方式：">
                <el-select clearable v-model="formInline.selectQuestionType">
                    <el-option label="随机" value="random"></el-option>
                    <el-option label="固定" value="fixed"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="发布状态：">
                <el-select clearable v-model="formInline.publishStatus">
                    <el-option label="已发布" :value="true"></el-option>
                    <el-option label="未发布" :value="false"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="search()">搜索</el-button>
                <el-button v-buttonAuth="'system:exam:add'" size="small" type="primary"
                    @click="handleEdit()">新建</el-button>
            </el-form-item>
        </el-form>
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData"
                :loading="tableForm.isLoading">
                <template #examName="item">
                    <a class="cs-pit col-29f" @click="handleShow(item.row)">
                        {{ item.row.examName }}
                    </a>
                </template>
                <el-table-column align="center" prop="userSex" label="操作" width="180">


                    <template slot-scope="scope">
                        <el-button type="text" v-if="!scope.row.publishStatus"
                            @click="handleEdit(scope.$index, scope.row)"
                            v-buttonAuth="'system:exam:edit'">编辑</el-button>
                        <el-popconfirm title="确认删除吗？" @confirm="removeExam(scope.$index, scope.row)">
                            <el-button type="text" slot="reference" class="col-f4d"
                                v-buttonAuth="'system:exam:delete'">删除</el-button>
                        </el-popconfirm>
                        <el-button type="text" class="col-f4d" v-if="!scope.row.publishStatus"
                            @click="handlePublish(scope.row)" v-buttonAuth="'system:exam:release'">发布</el-button>
                        <el-button type="text" class="col-999" v-buttonAuth="'system:exam:records'"
                            @click="goRecords(scope.row)">考试记录</el-button>
                        <el-button type="text" class="col-999" v-buttonAuth="'system:exam:preview'"
                            @click="preview(scope.row)">预览试卷</el-button>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        <el-dialog :title="title" :visible.sync="editFormVisible" :close-on-click-modal="false"
            custom-class="form-dialog" width="70%" @close='closeDialog("edit")'>
            <my-form :form-config="formConfig.formItems" ref="editForm" :disable-form="formConfig.disabled"
                :formRules="formConfig.formRules" :dataForm="formConfig.dataForm">
                <template #selectQuestionType>
                    <el-radio-group v-model="formConfig.dataForm.selectQuestionType" @change="changeMode()">
                        <el-radio label="fixed">固定</el-radio>
                        <el-radio label="random">随机</el-radio>
                    </el-radio-group>
                </template>
                <template #type>
                    <el-radio-group v-model="formConfig.dataForm.type" @change="changeType()">
                        <el-radio :label="false">否</el-radio>
                        <el-radio :label="true">是</el-radio>
                    </el-radio-group>
                </template>
                <template #table>
                    <my-table :height="300" :columns="dialogTable.customColumns" :tableData="dialogTable.tableData"
                        :tableConfig="dialogTable.config" :loading="dialogTable.isLoading">
                        <el-table-column align="center" prop="userSex" v-if="!formConfig.dataForm.type" label="分数"
                            width="180">
                            <template slot-scope="scope">
                                <el-input-number v-model="scope.row.questionScore" @change="setScore()"
                                    controls-position="right" :min="0"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column prop="userSex" label="操作" width="180" v-if="!formConfig.disabled">
                            <template slot-scope="scope">
                                <el-button type="primary" v-if="scope.$index !== 0" icon="el-icon-sort-up" circle
                                    @click="handleUp(scope.$index)"></el-button>
                                <el-button type="primary" v-if="scope.$index !== dialogTable.tableData.length - 1"
                                    icon="el-icon-sort-down" circle @click="handleDown(scope.$index)"></el-button>
                                <el-button type="primary" icon="el-icon-delete" circle
                                    @click="handleDelete(scope.$index)"></el-button>
                            </template>
                        </el-table-column>
                    </my-table>
                    <el-button v-if="!formConfig.disabled" type="primary" class="mg-tp10"
                        @click="handleAddTopic()">+添加问题</el-button>
                </template>
                <template #userIds>
                    <div>已选择：{{ dialogSelectData.beforeType == formConfig.dataForm.examType ?
                        formConfig.selectTraineeLabel : '-'
                        }}
                    </div>
                    <el-button type="primary" @click="showSelectDialog()">添加培训{{ formConfig.dataForm.examType ===
                        'dept'
                        ? '部门' :
                        '人员' }}</el-button>
                </template>
                <template #deptIds>
                    <div>已选择：{{ dialogSelectData.beforeType == formConfig.dataForm.examType ?
                        formConfig.selectTraineeLabel : '-'
                        }}
                    </div>
                    <el-button type="primary" @click="showSelectDialog()">添加培训{{ formConfig.dataForm.examType ===
                        'dept'
                        ? '部门' :
                        '人员' }}</el-button>
                </template>
            </my-form>
            <div slot="footer" class="dialog-footer" v-if="!formConfig.disabled">
                <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog title="选择题目" :visible.sync="topicDialog.visible" :close-on-click-modal="false"
            custom-class="form-dialog" width="70%" @before-close='closeTopicDialog("edit")'>
            <el-form :inline="true" size="small" :model="topicDialog.seachForm" class="user-search">
                <el-form-item label="科目类别：">
                    <el-select clearable v-model="topicDialog.seachForm.courseCategoryId">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in courseList" :key="item.courseCategoryId"
                            :label="item.courseCategoryName" :value="item.courseCategoryId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="题目类型：">
                    <el-select clearable v-model="topicDialog.seachForm.questionType">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in questionTypeList" :key="item.id" :label="item.label"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="题目内容：">
                    <el-input size="small" v-model="topicDialog.seachForm.questionTopicLike"
                        placeholder="请输入题目内容"></el-input>
                </el-form-item>
                <el-form-item label="关键字：">
                    <el-select clearable v-model="topicDialog.seachForm.key">
                        <el-option v-for="item in tagList" :key="item.keyTagId" :label="item.key"
                            :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="searchTopic()">搜索</el-button>
                </el-form-item>
            </el-form>
            <div class="main-table">
                <my-table :height="500" :columns="topicDialog.customColumns" :tableData="topicDialog.tableData"
                    :loading="topicDialog.isLoading" @selection-change="handleSelectionChange">
                </my-table>
            </div>
            <div class="main-pagination">
                <Pagination v-bind:child-msg="topicDialog.page" @callFather="changePage"></Pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='topicDialog.visible = false'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="saveTopic('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 全选内容 -->
        <myTransfer :traineeType="formConfig.dataForm.examType" :dialogSelectData="dialogSelectData"
            @confirmSelect="confirmSelect" @cancel="dialogSelectData.visible = false;">
        </myTransfer>
        <!-- <el-dialog title="选择" :visible.sync="dialogSelectData.visible" :close-on-click-modal="false" width="50%">
            <el-transfer v-model="dialogSelectData.selectVal" :titles="[`未选${formConfig.dataForm.examType ===
                'dept'
                ? '部门' : '人员'}`, `已选${formConfig.dataForm.examType ===
                    'dept'
                    ? '部门' : '人员'}`]" filterable :data="dialogSelectData.data"></el-transfer>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogSelectData.visible = false">取 消</el-button>
                <el-button type="primary" @click="confirmSelect()">确 定</el-button>
            </span>
        </el-dialog> -->
        <!-- 判断 -->
        <preview-papers @close="previewDialog.visible = false;" v-bind="previewDialog"
            :detailFn="detailFn"></preview-papers>
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myUpload from '@/components/myUpload.vue';
import previewPapers from '@/components/previewPapers.vue';
import myForm from '@/components/myForm.vue';
import store from '../../vuex/store';
import { capitalEnglishList, fileDownload, organizationName, questionTypeList } from "@/utils/util.js";
import { deptTree, deptList } from '@/api/dept.js'
import myTransfer from '@/components/myTransfer';
import { tagList } from '@/api/keys';
import { archiveBaseList } from '@/api/employee';
import courseApi from '@/api/onlineTraining/classification.js'
import { questionPage } from '@/api/topic.js'
import { examPaperPage, examPaperEdit, examPaperAdd, examPaperPublish, examPaperDetail, examPaperRemove } from '@/api/exam.js'
export default {
    components: {
        MyTable,
        Pagination,
        myUpload,
        myForm,
        previewPapers,
        myTransfer
    },
    watch: {
        'formConfig.dataForm.radioScore': {
            handler (val) {
                console.log(123);
                this.setAllScore();
            }
        },
        'formConfig.dataForm.checkScore': {
            handler (val) {
                this.setAllScore()
            }
        },
        'formConfig.dataForm.judgeScore': {
            handler (val) {
                this.setAllScore()
            }
        },
        'formConfig.dataForm.questionNum': {
            handler (val) {
                this.formConfig.dataForm.passNum = this.formConfig.dataForm.questionNum < this.formConfig.dataForm.passNum ? this.formConfig.dataForm.questionNum : this.formConfig.dataForm.passNum;
                this.formConfig.formItems[14].max = this.formConfig.dataForm.questionNum || 0;
            }
        },
        'formConfig.dataForm.totalScore': {
            handler (val) {
                this.formConfig.dataForm.passScore = this.formConfig.dataForm.totalScore < this.formConfig.dataForm.passScore ? this.formConfig.dataForm.totalScore : this.formConfig.dataForm.passScore;
                this.formConfig.formItems[16].max = this.formConfig.dataForm.totalScore || 0;
            }
        },
        'formConfig.dataForm.examType' (i, j) {
            this.changeExamType()
        }

    },
    data () {
        return {
            commonDept: [],
            commonUser: [],
            courseList: [],
            formInline: {
                courseCategoryId: '',
                examNameLike: '',
                publishStatus: '',
                selectQuestionType: '',
            },
            questionTypeList: questionTypeList,
            tableForm: {
                customColumns: [
                    { label: '所属机构', prop: 'name', formatter: () => { return organizationName } },
                    { label: '试卷编码', prop: 'examCode' },
                    { label: '试卷名称', slot: 'examName' },
                    { label: '科目类别', prop: 'courseCategoryName' },
                    { label: '命题方式', prop: 'selectQuestionType', formatter: (item) => { return item == 'random' ? '随机' : item == 'fixed' ? '固定' : '-' } },
                    { label: '题目总数', prop: 'questionNum' },
                    { label: '试卷总分', prop: 'totalScore' },
                    { label: '及格题目数', prop: 'passNum' },
                    { label: '及格分数', prop: 'passScore' },
                    { label: '考试时长（min)', prop: 'examTimeLength' },
                    { label: '截止提交日期', prop: 'expireCommitData' },
                    { label: '创建人', prop: 'createBy' },
                    { label: '创建时间', prop: 'createTime' },
                    { label: '发布状态', prop: 'publishStatus', formatter: (item) => { return item ? '<span style="color:green">已发布</span>' : '<span style="color:red">未发布</span>' } },
                ],
                tableData: [
                ],
                isLoading: false,
            },
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            editFormVisible: false, //控制编辑页面显示与隐藏
            title: '添加题目',
            // 编辑与添加
            formConfig: {
                formItems: [
                    { type: 'select', prop: 'courseCategoryId', label: '科目类别:', options: [] },
                    {
                        type: 'cascader', prop: 'deptIds', hide: true, label: '适用部门:', options: []
                        , property: {
                            clearable: true,
                            filterable: true,
                            'collapse-tags': true,
                            'show-all-levels': false,
                            props: {
                                label: 'deptName', value: 'deptId',
                                checkStrictly: true,
                                emitPath: false,
                                multiple: true,

                            }

                        },
                    },
                    { type: 'input', prop: 'examName', label: '试卷名称:', },

                    {
                        type: 'date', prop: 'expireCommitData', label: '截止提交日期:',
                        property: {
                            pickerOptions: {
                                disabledDate (time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                },
                            }
                        }
                    },
                    { prop: 'selectQuestionType', label: '命题方式:' },
                    { prop: 'type', label: '是否按题目类型给分:', hide: true },
                    //固定  是 ：start
                    { type: 'number', prop: 'radioScore', label: '单选分值:', hide: true, min: 0 },
                    { type: 'number', prop: 'checkScore', label: '多选分值:', hide: true, min: 0 },
                    { type: 'number', prop: 'judgeScore', label: '判断分值:', hide: true, min: 0 },

                    // end 

                    { prop: 'table', label: '', hide: true },
                    //固定  是 ：start
                    { type: 'number', prop: 'radioAllScore', label: '单选总分:', hide: true, disable: true, min: 0 },
                    { type: 'number', prop: 'checkAllScore', label: '多选总分:', hide: true, disable: true, min: 0 },
                    { type: 'number', prop: 'judgeAllScore', label: '判断总分:', hide: true, disable: true, min: 0 },
                    //end
                    //随机 start
                    {
                        type: 'number', prop: 'questionNum', label: '题目总数量:', disable: false, min: 0,
                        property: {
                            precision: 0,
                        }
                    },
                    {
                        type: 'number', prop: 'passNum', label: '及格题目数量:',
                        hide: false,
                        min: 0,
                        property: {
                            precision: 0,
                        }
                    },
                    //固定  否 ：start

                    { type: 'number', prop: 'totalScore', label: '试卷总分:', disable: true, hide: true, min: 0 },
                    { type: 'number', prop: 'passScore', label: '及格分数:', hide: true, min: 0 },

                    // end 
                    {
                        type: 'number', prop: 'examTimeLength', label: '考试时长（min）:', min: 0,

                    },
                    {
                        type: 'number', prop: 'joinTimesLimit', label: '可提交次数:', min: 0, property: {
                            precision: 0,
                        }
                    },
                    {
                        type: 'radio', prop: 'examType', label: '考试人员:', options: [
                            {
                                label: '指定部门考试',
                                id: 'dept'
                            },
                            {
                                label: '指定人员考试',
                                id: 'user'
                            }

                        ]
                    },
                    {
                        prop: 'userIds', label: '', hide: true, options: [],
                        property: {
                            multiple: true
                        }
                    },
                    {
                        prop: 'deptIds', label: '', options: [],
                        property: {
                            clearable: true,
                            filterable: true,
                            'show-all-levels': false,
                            props: {
                                label: 'deptName', value: 'deptId', checkStrictly: true, emitPath: false,
                                multiple: true
                            }
                        },
                    },
                ],
                selectTraineeLabel: '',
                formRules: {
                    courseCategoryId: [
                        { required: true, message: '请选择科目类别', trigger: 'change' },
                    ],

                    examName: { required: true, message: '请输入试卷名称', trigger: 'blur' },
                    expireCommitData: { required: true, message: '请选择截止提交日期', trigger: 'change' },
                    type: { required: true, message: '是否按题目类型给分', trigger: 'change' },
                    questionNum: { required: true, message: '请选择题目', trigger: 'change' },
                    radioScore: { required: true, message: '请输入分值', trigger: 'blur' },
                    checkScore: { required: true, message: '请输入分值', trigger: 'blur' },
                    judgeScore: { required: true, message: '请输入分值', trigger: 'blur' },
                    radioAllScore: { required: true, message: '请输入分值', trigger: 'blur' },
                    checkAllScore: { required: true, message: '请输入分值', trigger: 'blur' },
                    judgeAllScore: { required: true, message: '请输入分值', trigger: 'blur' },
                    passNum: { required: true, message: '请输入及格题目数量', trigger: 'blur' },

                    totalScore: { required: true, message: '请输入试卷总分', trigger: 'blur' },
                    passScore: { required: true, message: '请输入及格分数', trigger: 'blur' },
                    examTimeLength: { required: true, message: '请输入考试时长', trigger: 'blur' },
                    joinTimesLimit: { required: true, message: '请输入可提交次数', trigger: 'blur' },
                },
                dataForm: {
                    selectQuestionType: 'random',
                    type: false,
                    expireCommitData: '',
                    passScore: 0,
                    passNum: 0,
                    deptIds: [],
                    questionNum: 0,
                    totalScore: 0,
                    examTimeLength: 30,
                    radioScore: 0,
                    checkScore: 0,
                    judgeScore: 0,
                    examType: 'dept',
                }
            },
            questionOption: {},
            dialogTable: {
                customColumns: [
                    { label: '题目类型', prop: 'questionTypeText' },
                    { label: '题目', prop: 'questionTopic' },
                ],
                tableData: [
                ],
                config: {
                    isIndex: true,
                    noCheck: true
                },
                isLoading: false,
            },
            topicDialog: {
                seachForm: {
                    courseCategoryId: '',
                    questionTopicLike: '',
                    questionType: '',
                    key: '',
                },
                visible: false,
                customColumns: [
                    { label: '编码', prop: 'questionCode' },
                    { label: '科目类别', prop: 'courseCategoryName' },
                    { label: '题目类型', prop: 'questionTypeText' },
                    { label: '关键字', prop: 'keys', formatter: (keys) => { return keys ? keys.join(',') : '' } },
                    { label: '题目内容', prop: 'questionTopic' },
                ],
                tableData: [
                ],
                page: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                },
                checkList: [],
                isLoading: false,
            },
            previewDialog: {
                isPreview: false,
                examId: '',
                visible: false
            },
            dialogSelectData: {
                visible: false,
                data: [],
                beforeType: '',
                selectVal: []
            },
            commonAllDept: [],
            tagList: []
        }
    },

    created () {
        this.getDictionary();
        this.getData();
        this.getDeptTree();
        this.formConfig.formItems[14].max = this.formConfig.dataForm.questionNum || 0;
        this.formConfig.formItems[16].max = this.formConfig.dataForm.totalScore || 0;
    },
    methods: {
        async getDeptTree () {
            const res = await deptTree();
            this.commonDept = res.data;
            const allDept = await deptList({
                "pageNum": 1,
                "pageSize": 9999
            })
            this.commonAllDept = allDept.data;
            const archiveRes = await archiveBaseList({});
            this.commonUser = archiveRes.data.map(item => {
                return { ...item, label: item.userName, id: item.archiveId };
            });
            this.formConfig.formItems[21].options = this.commonDept;
            this.formConfig.formItems[20].options = this.commonUser;
        },
        setAllScore () {
            if (!this.formConfig.dataForm.type) return;
            this.formConfig.dataForm.radioAllScore = (this.formConfig.dataForm.radioScore || 0) * (this.dialogTable.tableData.filter(el => el.questionType == 1).length)
            this.formConfig.dataForm.checkAllScore = (this.formConfig.dataForm.checkScore || 0) * (this.dialogTable.tableData.filter(el => el.questionType == 2).length)
            this.formConfig.dataForm.judgeAllScore = (this.formConfig.dataForm.judgeScore || 0) * (this.dialogTable.tableData.filter(el => el.questionType == 3).length)
            this.formConfig.dataForm.totalScore = (this.formConfig.dataForm.checkAllScore || 0) + (this.formConfig.dataForm.radioAllScore || 0) + (this.formConfig.dataForm.judgeAllScore || 0)

        },
        async getDictionary () {
            const courseRes = (await courseApi.courseCategoryList({ pageNum: 1, pageSize: 999999, stateSign: true })).data;
            this.formConfig.formItems[0].options = courseRes.map(el => {
                return {
                    ...el,
                    id: el.courseCategoryId,
                    label: el.courseCategoryName
                }
            });
            this.courseList = courseRes;
            const tagRes = (await tagList({ stateSign: true })).data;
            this.tagList = tagRes;
        },
        search () {
            this.pageparm.currentPage = 1;
            this.getData();
        },
        async getData () {
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
                ...this.formInline,
            }
            const res = await examPaperPage(params);
            this.tableForm.tableData = res.data.records;
            this.pageparm.total = res.data.total;
        },
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.getData();
        },
        handleShow (row) {
            this.formConfig.disabled = true;
            this.editFormVisible = true;
            this.title = '查看试卷';
            this.dialogTable.tableData = []
            this.setFormData(row)
        },
        handleEdit (index, row) {
            this.formConfig.disabled = false;
            this.editFormVisible = true;
            this.dialogTable.tableData = []
            if (row != undefined && row != 'undefined') {
                this.title = '修改试卷'
                this.setFormData(row)
            } else {
                this.formConfig.selectTraineeLabel = '';
                this.formConfig.dataForm = {
                    selectQuestionType: 'random',
                    type: false,
                    expireCommitData: '',
                    deptIds: [],
                    passScore: 0,
                    passNum: 0,
                    questionNum: 0,
                    totalScore: 0,
                    examTimeLength: 30,
                    radioScore: 0,
                    checkScore: 0,
                    judgeScore: 0,
                    radioAllScore: 0,
                    checkAllScore: 0,
                    judgeAllScore: 0,
                    examType: 'dept',
                };
                this.title = '添加试卷'
                this.$forceUpdate()
                this.dialogTable.tableData = [];
                this.changeMode()
                if (this.$refs.editForm) {
                    this.$refs.editForm.$refs.form.resetFields();
                }
            }
        },
        setFormData (row) {
            this.formConfig.dataForm = JSON.parse(JSON.stringify(row));
            this.formConfig.dataForm.type = false;
            if (row.extend && row.extend.radioScore) {
                const { extend } = JSON.parse(JSON.stringify(row));
                this.$set(this.formConfig.dataForm, 'radioScore', extend.radioScore)
                this.$set(this.formConfig.dataForm, 'checkScore', extend.checkScore)
                this.$set(this.formConfig.dataForm, 'judgeScore', extend.judgeScore)
                this.$set(this.formConfig.dataForm, 'radioAllScore', extend.radioAllScore)
                this.$set(this.formConfig.dataForm, 'checkAllScore', extend.checkAllScore)
                this.$set(this.formConfig.dataForm, 'judgeAllScore', extend.judgeAllScore)
                this.$set(this.formConfig.dataForm, 'type', extend.type)
            };
            this.dialogSelectData.beforeType = row.examType;
            this.formConfig.selectTraineeLabel = row.examType == 'dept' ? row.deptNames.toString() : row.userNames.toString()

            this.changeExamType();
            this.dialogTable.tableData = JSON.parse(JSON.stringify(row.questionContent || []))
            this.$forceUpdate()
            this.changeMode()
        },
        async removeExam (index, row) {
            const res = await examPaperRemove([row.examPaperId]);
            this.getData();

        },
        changeExamType () {
            this.formConfig.formItems[21].hide = true;
            this.formConfig.formItems[20].hide = true;
            console.log(this.formConfig.dataForm.examType);
            if (this.formConfig.dataForm.examType === 'dept') {
                this.formConfig.dataForm.userIds = [];
                this.formConfig.formItems[21].options = this.commonDept;
                this.formConfig.formItems[21].hide = false;
            } else {
                this.formConfig.dataForm.deptIds = [];
                this.formConfig.formItems[20].options = this.commonUser;
                this.formConfig.formItems[20].hide = false;
            }
        },
        handlePublish (row) {
            this.$confirm('是否确认发布?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await examPaperPublish([row.examPaperId]);
                    if (res.code == 200) {
                        this.$message({ message: '发布成功', type: 'success' });
                        this.getData();
                    }

                })
        },
        // 操作命题方式
        changeMode () {
            this.changeType()
            console.log(this.formConfig.dataForm.selectQuestionType);
            if (this.formConfig.dataForm.selectQuestionType == 'fixed') {
                this.formConfig.formItems[5].hide = false;
                this.formConfig.formItems[9].hide = false;
                this.formConfig.formItems[13].disable = true;
                this.formConfig.formItems[14].hide = true;
                this.formConfig.formItems[15].hide = false;
                this.formConfig.formItems[16].hide = false;
            } else {
                this.$set(this.formConfig.formItems[5], 'hide', true)
                this.formConfig.formItems[5].hide = true;
                this.formConfig.formItems[9].hide = true;
                this.formConfig.formItems[13].disable = false;
                this.formConfig.formItems[14].hide = false;
                this.formConfig.formItems[15].hide = true;
                this.formConfig.formItems[16].hide = true;
            }
            this.$forceUpdate()
        },
        changeType () {
            if (this.formConfig.dataForm.type && this.formConfig.dataForm.selectQuestionType == 'fixed') {
                this.formConfig.formItems[6].hide = false;
                this.formConfig.formItems[7].hide = false;
                this.formConfig.formItems[8].hide = false;
                this.formConfig.formItems[10].hide = false;
                this.formConfig.formItems[11].hide = false;
                this.formConfig.formItems[12].hide = false;
            } else {
                this.formConfig.formItems[6].hide = true;
                this.formConfig.formItems[7].hide = true;
                this.formConfig.formItems[8].hide = true;
                this.formConfig.formItems[10].hide = true;
                this.formConfig.formItems[11].hide = true;
                this.formConfig.formItems[12].hide = true;
            }
            this.setScore()
        },
        //选择题目 dialog
        handleAddTopic () {
            this.getTopicList();
            this.topicDialog.visible = true;

        },
        searchTopic () {
            this.topicDialog.page.pageNum = 1;
            this.getTopicList();
        },
        async getTopicList () {
            this.topicDialog.checkList = [];
            const params = {
                pageNum: this.topicDialog.page.pageNum,
                pageSize: this.topicDialog.page.pageSize,
                ...this.topicDialog.seachForm,
                questionIdsNotIn: this.dialogTable.tableData.map(item => item.questionId)
            }
            const res = await questionPage(params);
            this.topicDialog.tableData = res.data.records;
            this.topicDialog.page.total = res.data.total;
        },
        closeTopicDialog () {
            this.topicDialog.seachForm = {
                courseCategoryId: '',
                questionType: '',
                questionTopicLike: '',
            };
            this.topicDialog.page.pageNum = 1;
            this.topicDialog.page.pageSize = 10;
            this.topicDialog.visible = false;
            this.topicDialog.checkList = []
        },
        saveTopic () {
            if (this.topicDialog.checkList.length > 0) {
                this.dialogTable.tableData = [...this.dialogTable.tableData, ...this.topicDialog.checkList];
            }
            this.closeTopicDialog();
            this.setScore()
        },
        changePage (parm) {
            this.topicDialog.page.pageNum = parm.currentPage;
            this.topicDialog.page.pageSize = parm.pageSize;
            this.getTopicList();
        },
        handleSelectionChange (selection) {
            this.topicDialog.checkList = selection;
        },
        setScore () {
            this.formConfig.dataForm.questionNum = this.dialogTable.tableData.length;
            if (this.formConfig.dataForm.type) {
                this.setAllScore()
            } else {
                this.formConfig.dataForm.totalScore = this.dialogTable.tableData.reduce((total, item) => total + item.questionScore || 0, 0);

            }
        },
        //end 选择题目 dialog
        // 上移
        handleUp (index) {
            this.dialogTable.tableData.splice(index - 1, 0, this.dialogTable.tableData.splice(index, 1)[0])
        },
        //下移
        handleDown (index) {
            this.dialogTable.tableData.splice(index + 1, 0, this.dialogTable.tableData.splice(index, 1)[0])
        },
        //删除
        handleDelete (index) {
            this.dialogTable.tableData.splice(index, 1);
            this.setScore();
        },
        //关闭
        closeDialog (dialog) {
            this.$refs.editForm.$refs.form.resetFields();
            this.editFormVisible = false
        },
        //提交
        submitForm (editData) {
            let data = JSON.parse(JSON.stringify(this.formConfig.dataForm));
            this.$refs.editForm.$refs.form.validate(async valid => {
                if (valid) {
                    if (data.selectQuestionType === 'fixed') {
                        data.questionContent = this.dialogTable.tableData;
                        if (data.type) {
                            data.extend = {
                                type: data.type,
                                radioScore: data.radioScore,
                                checkScore: data.checkScore,
                                judgeScore: data.judgeScore,
                                radioAllScore: data.radioAllScore,
                                checkAllScore: data.checkAllScore,
                                judgeAllScore: data.judgeAllScore
                            };
                            data.questionContent.forEach(e => {
                                if (e.questionType == 1) {
                                    e.questionScore = data.radioScore
                                } else if (e.questionType == 2) {
                                    e.questionScore = data.checkScore
                                } else if (e.questionType == 3) {
                                    e.questionScore = data.judgeScore
                                }
                            });
                        } else {
                            data.extend = {
                                type: data.type,
                            }
                        };
                    };
                    if (data.selectQuestionType == 'random') {
                        delete data.extend;
                        delete data.totalScore;
                        delete data.passScore;
                    } else {
                        delete data.passNum;
                    }
                    const res = await (data.examPaperId ? examPaperEdit(data) : examPaperAdd(data));
                    this.closeDialog();
                    await this.getData();
                    this.$message.success(res.msg);
                    // 请求方法
                } else {
                    return false
                }
            })
        },


        goRecords (item) {
            this.$router.push({ path: '/training/examinationRecord', query: { examPaperId: item.examPaperId, examNameLike: item.examName } });
        },
        preview (row) {
            this.previewDialog.visible = true;
            this.previewDialog.examId = row.examPaperId;
            this.previewDialog.isPreview = true;
        },
        detailFn () {
            return examPaperDetail(this.previewDialog.examId)
        },
        showSelectDialog () {
            this.dialogSelectData.visible = true;
            if (this.dialogSelectData.beforeType === this.formConfig.dataForm.examType) {
                this.dialogSelectData.selectVal = this.formConfig.dataForm.examType === 'dept' ? this.formConfig.dataForm.deptIds : this.formConfig.dataForm.userIds;
            } else {
                this.dialogSelectData.selectVal = []
            }
            this.dialogSelectData.beforeType = this.formConfig.dataForm.examType;
        },
        // 确认选择
        confirmSelect (selectVal, selectTraineeLabel) {
            this.formConfig.selectTraineeLabel = selectTraineeLabel;
            if (this.formConfig.dataForm.examType === 'dept') {
                this.$set(this.formConfig.dataForm, 'deptIds', selectVal)
                this.$refs.editForm.$refs.form.validateField('deptIds')
            } else {
                this.$set(this.formConfig.dataForm, 'userIds', selectVal)
                this.$refs.editForm.$refs.form.validateField('userIds')
            }
            this.dialogSelectData.visible = false;

        }
    }

}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}

.option-from {
    font-size: 14px;
    margin-bottom: 10px;
    color: #333333;
}
</style>


// WEBPACK FOOTER //
// src/views/training/examination.vue